import { createRouter, createWebHistory } from 'vue-router'
import { usePostCategoryStore } from '@/stores/postCategory'
import { useUserStore } from '@/stores/user'

const routes = [
    {
        path: '',
        redirect: '/ads',
        component: () => import('@/views/home/home.vue'),
        meta: { title: '华蒙驿站-首页' },
        children: [
            // 特殊布局的页面单独配置
            {
                path: 'ads',
                component: () => import('@/views/home/ads.vue'),
                meta: { title: '华蒙驿站-推荐' }
            },
            // 动态路由配置，用于list布局的页面
            {
                path: ':category',  // 动态路径参数
                component: () => import('@/views/home/ListLayout.vue'),  // 通用list布局
                meta: { title: '华蒙驿站-信息列表' }
            }
        ]
    },
    {
        path: '/info/:id',
        name: 'info',
        component: () => import('@/views/post/info.vue'),
        meta: { title: '华蒙驿站-信息详情' }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/user/Login.vue'),
        meta: { title: '华蒙驿站-登录' }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/user/Register.vue'),
        meta: { title: '华蒙驿站-注册' }
    },
    {
        path: '/user',
        name: 'user',
        component: () => import('@/views/user/User.vue'),
        meta: { title: '华蒙驿站-个人中心', requiresAuth: true }
    },
    {
        path: '/create',
        name: 'create',
        component: () => import('@/views/post/create.vue'),
        meta: { title: '华蒙驿站-发布信息', requiresAuth: true }
    },
    {
        path: '/createAds',
        name: 'createAds',
        component: () => import('@/views/ads/createAds.vue'),
        meta: { title: '华蒙驿站-发布广告', requiresAuth: true }
    },
    {
        path:'/adsInfo/:id',
        name:'adsInfo',
        component:()=>import('@/views/ads/adsInfo.vue'),
        meta:{title:'华蒙驿站-广告详情'}
    },
    {
        path:'/adsList',
        name:'adsList',
        component:()=>import('@/views/ads/adsList.vue'),
        meta:{title:'华蒙驿站-广告列表'}
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('@/views/NotFound.vue'),
        meta: { title: '页面未找到' }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
    // 设置页面标题
    document.title = to.meta.title || '本地信息网'

    // 检查是否从 create 页面来的
    const fromCreate = sessionStorage.getItem('fromCreate')
    
    
    // 如果用户在用户页面并尝试返回到 create 页面，且是从创建成功后跳转来的
    if (from.path === '/user' && 
        to.path === '/create' && 
        fromCreate === 'true') {
        // 清除标记
        sessionStorage.removeItem('fromCreate')
        // 阻止返回到 create 页面，而是返回到首页或其他合适的页面
        next('/')
        return
    }

    // 初始化用户信息
    const userStore = useUserStore()
    userStore.initUserInfo()
    // 初始化分类 store
    const postCategoryStore = usePostCategoryStore()

    // 如果还没有加载分类数据，加载分类数据
    if (postCategoryStore.postCategory.length === 0) {
        try {
            await postCategoryStore.fetchCategories()
           
            
            // 如果当前路由包含 category 参数，验证其有效性
            if (to.params.category) {
                const isValidCategory = postCategoryStore.postCategory.some(
                    cat => cat.slug === to.params.category
                )

                if (!isValidCategory) {
                    // 无效分类重定向到首页
                    next('/')
                    return
                }
            }
        } catch (error) {
            console.error('加载分类失败:', error)
            // 可以选择重定向到错误页面
            next('/error')
            return
        }
    }

    // 检查是否需要登录
    if (to.meta.requiresAuth) {
        // 使用 store 中的 isLoggedIn 方法检查登录状态
        if (!userStore.isLoggedIn()) {
            // 保存原始路径到 sessionStorage
            sessionStorage.setItem('redirectPath', to.fullPath)

            next({
                path: '/login'
            })
            return
        }
    }
    // 如果用户已登录且试图访问登录页
    if (to.path === '/login' && userStore.isLoggedIn()) {
        // 如果有重定向路径，跳转到重定向路径
        const redirectPath = sessionStorage.getItem('redirectPath')
        if (redirectPath) {
            sessionStorage.removeItem('redirectPath')
            next(redirectPath)
        } else {
            // 否则跳转到首页
            next('/')
        }
        return
    }

    next()
})

export default router